import { YesNoUnknown } from "@nkr/enums/yes-no-unknown";

export interface IDashSearchResult {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    birthDate: string,
    registrationDate: string,
    hasNutcracker: YesNoUnknown
}